import React from 'react';
import { Mail, Building2, MessageSquare } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ContactSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-yellow-400 text-gray-900 rounded-full text-sm font-bold mb-4">
            {t('contact.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-xl text-gray-700">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Google Forms Iframe */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="relative w-full" style={{ paddingBottom: '149.5%' }}>
              <iframe 
                src="https://docs.google.com/forms/d/e/1FAIpQLSdVP5GBhbICC9e-vPnn7wn373vhI3mDO1lyK_v8T9hW0V_5Hw/viewform?embedded=true" 
                className="absolute top-0 left-0 w-full h-full border-0"
                title="İletişim Formu"
              >
                Yükleniyor…
              </iframe>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-white rounded-3xl p-8 shadow-lg transform hover:scale-105 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mb-6">
                <Mail className="h-8 w-8 text-gray-900" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('contact.emailTitle')}</h3>
              <a
                href="mailto:info@partnershippo.com"
                className="text-gray-900 hover:text-yellow-600 font-bold flex items-center group"
              >
                info@partnershippo.com
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform">→</span>
              </a>
              <p className="text-gray-600 mt-2">
                {t('contact.emailDescription')}
              </p>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-lg transform hover:scale-105 transition-all duration-300 border border-gray-100">
              <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mb-6">
                <Building2 className="h-8 w-8 text-gray-900" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{t('contact.linkedinTitle')}</h3>
              <a
                href="https://www.linkedin.com/company/partnershippo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-yellow-600 font-bold flex items-center group"
              >
                linkedin.com/company/partnershippo
                <span className="ml-2 transform group-hover:translate-x-1 transition-transform">→</span>
              </a>
            </div>

            <div className="bg-yellow-400 rounded-3xl p-8 shadow-lg">
              <MessageSquare className="h-12 w-12 mb-4 text-gray-900" />
              <h3 className="text-2xl font-bold mb-3 text-gray-900">{t('contact.partnerTitle')}</h3>
              <p className="text-gray-800 leading-relaxed">
                {t('contact.partnerDescription')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;